import React, { useState, useEffect } from "react";
import OverallPage from "../pages/OverallPage/OverallPage";
import SubjectWisePage from "../pages/SubjectWisePage/SubjectWisePage";
import TopicWisePage from "../pages/TopicWisePage/TopicWisePage";
import QuestionWisePage from "../pages/QuestionWisePage/QuestionWisePage";
import "./AdvanceAnalytics.scss";
import Header from "./Header/Header";
import { useLocation } from "react-router-dom";

const AdvanceAnalytics = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("overall");
  useEffect(() => {
    if (location?.state?.tab === "questionwise") {
      setActiveTab("questionwise");
    }
  }, [location]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "overall":
        return <OverallPage />;
      case "subjectwise":
        return <SubjectWisePage />;
      case "topicwise":
        return <TopicWisePage />;
      case "questionwise":
        return <QuestionWisePage />;
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="advanceAnalyticsWrapper">
        <div className="advanceAnalyticsTabs">
          <button
            className={`tabBtn ${activeTab === "overall" ? "active" : ""}`}
            onClick={() => setActiveTab("overall")}
          >
            Overall
          </button>

          <button
            className={`tabBtn ${activeTab === "subjectwise" ? "active" : ""}`}
            onClick={() => setActiveTab("subjectwise")}
          >
            Subject-wise
          </button>

          <button
            className={`tabBtn ${activeTab === "topicwise" ? "active" : ""}`}
            onClick={() => setActiveTab("topicwise")}
          >
            Topic-wise
          </button>

          <button
            className={`tabBtn ${activeTab === "questionwise" ? "active" : ""}`}
            onClick={() => setActiveTab("questionwise")}
          >
            Question-wise
          </button>
        </div>

        <div className="advanceAnalyticsContent">{renderTabContent()}</div>
      </div>
    </>
  );
};

export default AdvanceAnalytics;
